import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "rules-settings" }
const _hoisted_2 = { class: "parser" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "tools" }
const _hoisted_5 = { class: "tool" }
const _hoisted_6 = { class: "tool" }
const _hoisted_7 = ["checked", ".indeterminate"]
const _hoisted_8 = { class: "categories" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "category-title-wrapper" }
const _hoisted_11 = { class: "category-title" }
const _hoisted_12 = ["checked", ".indeterminate", "onInput"]
const _hoisted_13 = { class: "rules" }
const _hoisted_14 = ["checked", "onInput"]
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "parser-label" }, "Parser:", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parserIndex) = $event)),
          class: "parser-select"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PARSERS, (optParser, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: i
            }, _toDisplayString(optParser), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.parserIndex]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "tools-title",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.toolsClose = !_ctx.state.toolsClose))
      }, [
        _cache[6] || (_cache[6] = _createTextVNode(" Tools ")),
        _createElementVNode("button", {
          class: _normalizeClass(["tools-button", { 'tools-button--close': _ctx.state.toolsClose }])
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            height: "10",
            viewBox: "0 0 10 10",
            width: "10"
          }, [
            _createElementVNode("path", {
              d: "M2.5 10l5-5-5-5v10z",
              fill: "#ddd"
            })
          ], -1)
        ]), 2)
      ]),
      (!_ctx.state.toolsClose)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("label", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "tool-label" }, "Filter:", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterValue) = $event)),
                type: "search",
                placeholder: "Rule Filter",
                class: "tool-form"
              }, null, 512), [
                [_vModelText, _ctx.filterValue]
              ])
            ]),
            _createElementVNode("label", _hoisted_6, [
              _createElementVNode("input", {
                checked: 
              _ctx.categories.every((category) =>
                category.rules.every((rule) => _ctx.isErrorState(rule.ruleId)),
              )
            ,
                type: "checkbox",
                ".indeterminate": 
              _ctx.categories.some((category) =>
                category.rules.some((rule) => _ctx.isErrorState(rule.ruleId)),
              ) &&
              _ctx.categories.some((category) =>
                category.rules.some((rule) => !_ctx.isErrorState(rule.ruleId)),
              )
            ,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAllClick($event as MouseEvent)))
              }, null, 40, _hoisted_7),
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "All Rules", -1))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (category.rules.length)
            ? (_openBlock(), _createElementBlock("li", {
                key: category.title,
                class: _normalizeClass(["category", category.classes])
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["category-button", {
              'category-button--close': _ctx.categoryState[category.title].close,
            }]),
                  onClick: ($event: any) => (
              _ctx.categoryState[category.title].close =
                !_ctx.categoryState[category.title].close
            )
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "10",
                    viewBox: "0 0 10 10",
                    width: "10"
                  }, [
                    _createElementVNode("path", {
                      d: "M2.5 10l5-5-5-5v10z",
                      fill: "#ddd"
                    })
                  ], -1)
                ]), 10, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _createElementVNode("input", {
                      checked: 
                  category.rules.every((rule) => _ctx.isErrorState(rule.ruleId))
                ,
                      type: "checkbox",
                      ".indeterminate": 
                  !category.rules.every((rule) => _ctx.isErrorState(rule.ruleId)) &&
                  !category.rules.every((rule) => !_ctx.isErrorState(rule.ruleId))
                ,
                      onInput: ($event: any) => (_ctx.onCategoryClick(category, $event as MouseEvent))
                    }, null, 40, _hoisted_12),
                    _createTextVNode(" " + _toDisplayString(category.title), 1)
                  ])
                ]),
                _withDirectives(_createElementVNode("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.rules, (rule) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: rule.ruleId,
                      class: _normalizeClass(["rule", rule.classes])
                    }, [
                      _createElementVNode("label", null, [
                        _createElementVNode("input", {
                          checked: _ctx.isErrorState(rule.ruleId),
                          type: "checkbox",
                          onInput: ($event: any) => (_ctx.onClick(rule.ruleId, $event as MouseEvent))
                        }, null, 40, _hoisted_14),
                        _createTextVNode(" " + _toDisplayString(rule.ruleId), 1)
                      ]),
                      _createElementVNode("a", {
                        href: rule.url,
                        target: "_blank"
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          "aria-hidden": "true",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 100 100",
                          width: "15",
                          height: "15",
                          class: "icon outbound"
                        }, [
                          _createElementVNode("path", {
                            fill: "currentColor",
                            d: "M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z"
                          }),
                          _createElementVNode("polygon", {
                            fill: "currentColor",
                            points: "45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,14.9 62.8,22.9 71.5,22.9"
                          })
                        ], -1)
                      ]), 8, _hoisted_15)
                    ], 2))
                  }), 128))
                ], 512), [
                  [_vShow, !_ctx.categoryState[category.title].close]
                ])
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ]))
}